import { h } from "preact";
import NamesList from "../../result-list/authors-list";
import KeywordList from "../../result-list/keyword-list";
import QuotesList from "../../result-list/quotes-list";
import EmptyList from "../../result-list/empty-list";
import FilmList from "../../result-list/film-list";
import WorkList from "../../result-list/work-list";
import GenreList from "../../result-list/genre-list";

const SwitchList = ({ database, displayList, displayType, ...props }) => {
  if (database.startsWith("Ziekte")){
    database="ziektebiografie";
  }
  switch (database.toLowerCase()) {
    case "romans en verhalen":
    case "novels and stories":
      switch (displayList) {
        case "author":
          if (displayType === "name") {
            return (
              <NamesList
                databaseKey="roman"
                listPath="authorlist"
                resultLinkPath={`${props.locale}/roman/author`}
                {...props}
              />
            );
          }
          if (displayType === "keyword") {
            return (
              <KeywordList
                databaseKey="roman"
                resultLinkPath={`${props.locale}/roman/keyword`}
                {...props}
              />
            );
          }
          case "quote":
            return <QuotesList {...props} />;
          case "genre":
            return <GenreList databaseKey="roman" resultLinkPath={`${props.locale}/book/bygenre`} {...props} />;

        default:
          return <EmptyList />;
      }
    case "ziektebiografie":
    case "pathographies":
      return (
        <KeywordList
          databaseKey="pathography"
          resultLinkPath={`${props.locale}/pathography/keyword`}
          {...props}
        />
      );
    case "films en documentaires":
    case "film, documentary and television":
      switch (displayType) {
        case "keyword":
          return (
            <KeywordList
              databaseKey="film"
              resultLinkPath={`${props.locale}/film/keyword`}
              {...props}
            />
          );
        case "titel":
          return (
            <FilmList
              databaseKey="film"
              resultLinkPath={`${props.locale}/film/detail`}
              {...props}
            />
          );
        case "genre":
          return <GenreList databaseKey="film" resultLinkPath={`${props.locale}/film/bygenre`} {...props} />
      }
    case "beelden van geneeskunde":
    case "images of medicine":
      switch (displayType) {
        case "name":
          return (
            <NamesList
              databaseKey="art"
              listPath="artistlist"
              resultLinkPath={`${props.locale}/artist/detail`}
              {...props}
            />
          );
        case "keyword":
          return (
            <KeywordList
              databaseKey="art"
              listPath="keywordlist"
              resultLinkPath={`${props.locale}/art/bykeyword`}
              {...props}
            />
          );
      }
    case "over literatuur en geneeskunde":
    case "about literature and medicine":
      switch (displayType) {
        case "name":
          return (
            <NamesList
              databaseKey="about"
              listPath="authorlist"
              resultLinkPath={`${props.locale}/about/byauthor`}
              {...props}
            />
          );
        case "keyword":
          return (
            <KeywordList
              databaseKey="about"
              listPath="keywordlist"
              resultLinkPath={`${props.locale}/about/bykeyword`}
              {...props}
            />
          );
        case "work":
          return (
            <WorkList
              databaseKey="about"
              listPath="worklist"
              resultLinkPath={`${props.locale}/work/bykeyword`}
              {...props}
            />
          );
      }
    case "poëzie":
    case "poetry":
      switch (displayType) {
        case "poet":
          return (
            <NamesList
              databaseKey="poetry"
              listPath="poetlist"
              resultLinkPath={`${props.locale}/poetry/byartist`}
              {...props}
            />
          );
        case "keyword":
          return (
            <KeywordList
              databaseKey="poetry"
              listPath="keywordlist"
              resultLinkPath={`${props.locale}/poetry/bykeyword`}
              {...props}
            />
          );
      }
    default:
      return <EmptyList />;
  }
};

export default SwitchList;
